import * as React from "react";
import Modal from "@mui/material/Modal";
import {
  ModalDescription,
  ModalHeader,
  ModalTitle,
  StyledBox,
  StyledBoxShow,
  StyledImg,
  StyledLockerIdTypography,
  StyledTypographyCopy,
} from "./style";
import CustomButton from "../../common/button/CustomButton";
import profile from "../../../assets/images/featured-model-icon.png";
import theme from "../../../theme";
import close from "../../../assets/images/x-close-black.png";
import copyIcon from "../../../assets/images/copy-icon.png";
import { Box, Divider } from "@mui/material";
import { useSelector } from "react-redux";
import { formatToLongDate } from "../../../utils/common";
import toast from "react-hot-toast";

export default function CreateSuccessVirtual({ open, handleClose }) {
  const lockerGetDetails = useSelector(
    (state) => state?.address?.virtualAccept
  );

  const lockerId = lockerGetDetails?.locker_id;

  const handleCopy = () => {
    navigator.clipboard.writeText(lockerId);
    toast.success("Locker Id Copied Successfully");
  };
  return (
    <Modal open={open} onClose={handleClose}>
      <StyledBox>
        <ModalHeader>
          <img src={profile} alt="profile" loading="lazy" />
          <img
            src={close}
            alt="close"
            loading="lazy"
            height={38}
            onClick={() => handleClose()}
          />
        </ModalHeader>
        <ModalTitle>Virtual Locker Created Successfully!</ModalTitle>
        <ModalDescription>
          Thanks for sharing your details. Your Virtual Locker has been
          successfully set up!
        </ModalDescription>
        <Divider />

        <Box>
          <StyledLockerIdTypography>Locker ID</StyledLockerIdTypography>
          <StyledBoxShow>
            <StyledTypographyCopy>
              {lockerGetDetails?.locker_id}
            </StyledTypographyCopy>
            <StyledImg
              src={copyIcon}
              alt="copyIcon"
              loading="lazy"
              onClick={handleCopy}
            />
          </StyledBoxShow>
        </Box>

        <Box>
          <StyledLockerIdTypography>Created On</StyledLockerIdTypography>
          <StyledBoxShow>
            <StyledTypographyCopy>
              {formatToLongDate(lockerGetDetails?.assigned_date)}
            </StyledTypographyCopy>
          </StyledBoxShow>
        </Box>

        <CustomButton
          btntype={"primary"}
          color={theme.palette.custom.white}
          btnLabel={"View Locker"}
          onClick={() => {
            handleClose();
          }}
        />
      </StyledBox>
    </Modal>
  );
}
